import axios from "axios";

export const getDomains = async () => {
    return await axios.get(`${window.FormConfiguration['API_URL']}/v1/client/domains`);
}
